import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TPublicationToShare } from '../../../components/PublicationShareModal'
import { useSharePublication } from '../../../hooks/useSharePublication'

export const PublicationShareSection = ({ publication }: { publication: TPublicationToShare }): ReactNode => {
  const { t } = useTranslate()

  const { share, shareOnWhatsApp } = useSharePublication()

  return (
    <View className="flex flex-row  flex-wrap justify-center gap-4 md:flex-nowrap">
      <Button
        size="md"
        startIcon={ICON.WHATSAPP}
        variant="faded"
        colors="default"
        className="bg-social-whatsapp-50 enabled:hover:bg-social-whatsapp-100 md:w-1/2"
        textClassName="text-social-whatsapp-600"
        fullWidth
        onPress={() => shareOnWhatsApp(publication, TRACKING_SOURCE.PUBLICATION_PAGE)}
      >
        {t('share.wording.share-on-whatsapp')}
      </Button>

      <Button
        testID={TEST_ID.MISCELLANEOUS.PUBLICATION_SHARE_BUTTON}
        size="md"
        startIcon={ICON.SHARE}
        className="md:w-1/2"
        fullWidth
        variant="faded"
        colors="default"
        onPress={() => share(publication, TRACKING_SOURCE.PUBLICATION_PAGE)}
      >
        {t('cta.share')}
      </Button>
    </View>
  )
}
